import type { IntegrationKey } from '@centric-os/types';
import {
  EXTERNALLY_CONFIGURED_INTEGRATION_NAMES,
  INTEGRATION_DEFINITIONS,
} from '../../../constants/integrations';

/** True for Thrive and Boost, the app integrations set up on the app config page. */
export const isThriveOrBoost = (key: IntegrationKey) => key === 'thrive' || key === 'boost';

export const isIntegrationKey = (value: unknown): value is IntegrationKey =>
  typeof value === 'string' && Object.hasOwn(INTEGRATION_DEFINITIONS, value);

const isExternallyConfiguredIntegrationKey = (
  key: string,
): key is keyof typeof EXTERNALLY_CONFIGURED_INTEGRATION_NAMES =>
  Object.hasOwn(EXTERNALLY_CONFIGURED_INTEGRATION_NAMES, key);

/**
 * Display name for an integration key, e.g. one in a brand's `meta.software_integrations`: a
 * station integration's `displayName`, a name from `EXTERNALLY_CONFIGURED_INTEGRATION_NAMES`, or
 * the key itself when neither has it.
 */
export const getSoftwareIntegrationName = (key: string): string => {
  if (isIntegrationKey(key)) return INTEGRATION_DEFINITIONS[key].displayName;
  if (isExternallyConfiguredIntegrationKey(key))
    return EXTERNALLY_CONFIGURED_INTEGRATION_NAMES[key];
  return key;
};
